import { useMemo } from 'react';

import commonBanner from 'modules/referralProgram/assets/common-banner.png';
import { useFetchReferralProgramsQuery } from 'modules/strapi/actions/fetchReferralPrograms';

import { getReferralProgram } from '../utils/getReferralProgram';
import { useReferralCode } from './useReferralCode';

export interface IUseReferralProgramProps {
  referralCode?: string;
}

export const useReferralProgram = ({
  referralCode: externalReferralCode,
}: IUseReferralProgramProps | void = {}) => {
  const { referralCode: referralCodeFromUrlOrStore } = useReferralCode();

  const { data: referralPrograms } = useFetchReferralProgramsQuery();

  const referralCode = externalReferralCode || referralCodeFromUrlOrStore;

  const referralProgram = useMemo(
    () => getReferralProgram({ referralCode, referralPrograms }),
    [referralCode, referralPrograms],
  );

  const cover = referralProgram?.cover || commonBanner;

  return { cover, referralCode, referralProgram };
};
